import { DATA_SOURCE_IDS } from '@discover-frontend/constants';

export const isStanleyQuerySupportedDataSource = (
  dataSource?: string | null
): boolean => dataSource === DATA_SOURCE_IDS.TWITTER;
